import { areYearMonthDateEqual, mergeDateAndTime } from '@occc-app/lib/date';
import { dateFNSAddMinutes, dateFNSSubMinutes } from '@occc-app/lib/util-location-schedule';

import { ScheduleDatesFormValues } from './schemas/schedule-dates.schema';

export const calculateDateTimeConstraints = (values: ScheduleDatesFormValues) => {
  const publishAt = mergeDateAndTime(values.publishAtDate, values.publishAtTime);
  const expireAt = mergeDateAndTime(values.expireAtDate, values.expireAtTime);
  const minDate = publishAt ? dateFNSAddMinutes(publishAt, 1) : undefined;
  const maxDate = expireAt ? dateFNSSubMinutes(expireAt, 1) : undefined;

  const areDatesEqual =
    values.publishAtDate &&
    values.expireAtDate &&
    areYearMonthDateEqual(values.publishAtDate, values.expireAtDate);

  const minTime = areDatesEqual ? minDate : undefined;
  const maxTime = areDatesEqual ? maxDate : undefined;

  return { minDate, maxDate, maxTime, minTime };
};
